import type { FaireProductEntity } from "../../entity_types/product";

export const p_sw75hka46s: FaireProductEntity = {
  token: "p_sw75hka46s",
  type: "product",
  name: "Bunch of Dogs Red Porcelain Yunomi Tea Cup – 10 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/482202d19c1b90569de47e48a3f763b623c1d6b5aa37b6d98dc31f36fb4565ed.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da5ee6205e0f707d68eb7e469bb9d1fa59385290de682a6eed0fb92375f88ec8.jpeg",
    "https://cdn.faire.com/fastly/ed1de6e3dee42449f017cfd84b17ba88df4199bac4d92945ecf81b74974856cf.jpeg",
    "https://cdn.faire.com/fastly/f8536cf8845407a34dab04be54a3d3349bec4919c32bfd952518bc80d29ecb06.jpeg"
  ],
  priceDollars: 5.5,
  description: "Serve hot green tea the Japanese way with this 10 oz yunomi tea cup in Bunch of Dogs Red. It is decorated with a playful bunch of dogs in red. Made in Japan from durable porcelain, it is built for sushi bars, ramen shops, cafés and Japanese restaurants, while looking just as good at home. A thoughtful gift for tea lovers and dog lovers.\n\nFeatures\n\n * Classic yunomi shape: a tall, handleless cup that is comfortable to hold with both hands \n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 2.75\" Dia x 4\" H \n * Capacity: 10 fl oz \n * Material: Porcelain \n * Design: Bunch of Dogs Red \n * Inner pack: 6 \n * Case pack: 60 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:06.315Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
